import { useIntl } from "react-intl";

import BudgetKanbanStatusCounts from "./components/budgetKanbanStatusCounts";
import BudgetKanbanFilters from "./components/budgetKanbanFilters";
import BudgetKanbanBoard from "./components/budgetKanbanBoard";
import BudgetVersionsDialog from "./dialogs/budgetVersionsDialog";

import { useBudgetKanban } from "./hooks/useBudgetKanban";

interface BudgetsKanbanProps {
  persona?: string;
}

const BudgetsKanban = ({ persona }: BudgetsKanbanProps) => {
  const intl = useIntl();

  const {
    loading,
    columns,
    columnsData,
    statusCounts,
    filters,
    viewType,

    setFilters,
    setViewType,
    loadMoreBudgets,

    showHistoryModal,
    selectedBudget,

    handleCreateBudget,
    handleViewVersions,
    handleCloseHistoryModal
  } = useBudgetKanban(persona);

  return (
    <div className="p-5">
      <div className="mb-5 overflow-x-auto">
        <BudgetKanbanStatusCounts statusCounts={statusCounts} loading={loading} persona={persona} />
      </div>

      <div className="mb-5">
        <div className="w-full max-w-[2048px] mx-auto">
          <h2 className="text-2xl font-bold mb-4">{intl.formatMessage({ id: "intl-msg:budgets.kanban.title" })}</h2>
        </div>

        <BudgetKanbanFilters filters={filters} setFilters={setFilters} persona={persona} onCreateBudget={handleCreateBudget} />
      </div>

      <div className="mt-5 w-full">
        <BudgetKanbanBoard
          loading={loading}
          columns={columns}
          columnsData={columnsData}
          viewType={viewType}
          persona={persona}

          setViewType={setViewType}
          onViewVersions={handleViewVersions}
          loadMoreBudgets={loadMoreBudgets}
        />
      </div>

      {selectedBudget && (
        <BudgetVersionsDialog
          show={showHistoryModal}
          budget={selectedBudget}
          persona={persona ?? "fleet-manager"}
          onClose={handleCloseHistoryModal}
        />
      )}
    </div>
  );
};

export default BudgetsKanban;